<template>
  <div class="filter-tags">
    <h3 class="filter-tags__title">
      Showing
    </h3>
    <div class="filter-tags__list">
      <tag
        v-for="(name, i) in features"
        :key="`feature-${i}`"
        type="feature"
      >
        {{ name }}
      </tag>
      <template v-if="location">
        <span>in</span>
        <tag type="location">
          {{ location }}
        </tag>
      </template>
      <span>with</span>
      <tag
        v-for="(name, i) in amenities"
        :key="`amenities-${i}`"
        type="amenity"
      >
        {{ name }}
      </tag>
      <span>and</span>
      <tag
        v-for="(name, i) in poi"
        :key="`poi-${i}`"
        type="poi"
      >
        {{ name }}
      </tag>
      <span>rated</span>
      <tag
        v-for="(name, i) in rating"
        :key="`rating-${i}`"
        type="rating"
      >
        {{ name }}
      </tag>
    </div>
  </div>
</template>

<script>
import Tag from '../components/tiny/Tag';

export default {
  name: 'filter-tags',
  components: {
    Tag,
  },
  props: {
    features: {
      type: Array,
      default: null,
    },
    location: {
      type: String,
      default: '',
    },
    amenities: {
      type: Array,
      default: null,
    },
    poi: {
      type: Array,
      default: null,
    },
    rating: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.filter-tags {
  display: flex;
  align-items: baseline;
  &__list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 1;
    & > span {
      font-size: 13px;
      color: #6e7c91;
      font-weight: 700;
      margin: 5px;
    }
  }
  &__title {
    font-size: 13px;
    color: #6e7c91;
    font-weight: 700;
    margin: 5px;
  }
}
</style>
